import axiosInstance from '@/services/axios'

const endPoint = {
	lookupCategories: () => 'supplies/categories',
	lookupList: () => 'supplies/list',
	lookupBrands: () => 'supplies/brands',
}

const suppliesAPI = {
	// 시약 외 상품 카테고리 트리 (대분류 > 소분류, 건수 포함)
	lookupCategories: () => axiosInstance.get(endPoint.lookupCategories()),
	// 시약 외 상품 카드 목록
	lookupList: params => axiosInstance.get(endPoint.lookupList(), { params }),
	// 브랜드 필터 목록 (현재 카테고리/검색어에 해당하는 브랜드와 건수)
	lookupBrands: params => axiosInstance.get(endPoint.lookupBrands(), { params }),
}

export default suppliesAPI
